import {
	Button,
	Col,
	Input,
	MultipleRadio,
	Row,
	TSelectOption
} from '@microfrontends/react-components'
import {
	forwardRef,
	Ref,
	useContext,
	useEffect,
	useImperativeHandle,
	useRef,
	useState
} from 'react'
import AppContext from '../../context/AppContext'
import { NumerologyApi } from '../../services/numerology'
import { IBodyCheckingNumerology } from '../../services/numerology/@type'
import { IFormField, IFormValues, initValues, IOption } from './const'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
import styled from 'styled-components'
import { isMobile } from '../utils'
import { useRouter } from 'next/router'
import React from 'react'
import { noSpecialChars } from '../../helpers/regex'

const FormCss = styled.div`
	.form {
		.--relative {
			position: relative;
		}

		p.text-danger {
			font-size: 14px;
			margin-top: 4px;
			margin-bottom: 0;
		}
		label {
			font-weight: 500;
			font-size: 14px;
			line-height: 18px;
			position: relative;
			sup {
				color: #ff4a53;
				position: absolute;
				top: 6px;
				right: -10px;
			}
		}

		&__button {
			margin: 16px -16px 0 -16px;
			padding: 16px;
			border-top: 1px solid #efefef;
			.--button {
				margin-top: 5px;
				width: 100%;
			}
		}
	}
`

const serviceNumerology = new NumerologyApi()
interface IProps {
	handleOpen: () => void
}
export interface RefObj {
	handleResetFormValues: () => void
}

const NUMEROLOGY_CATEGORY_OTHER = 69

export const FormCheckNumerology = (
	{ handleOpen }: IProps,
	ref: Ref<RefObj>
) => {
	const { t, languageCode, user } = useContext(AppContext)
	const [levelsOption, setLevelsOption] = useState<IOption[] | null>(null)
	const [industryOption, setIndustryOption] = useState<IOption[] | null>(null)
	const [formValues, setFormValues] = useState<IFormValues>(initValues)
	const [industryOther, setIndustryOther] = useState<number>(0)
	const [errorMes, setErrorMes] = useState<{
		[key: string]: string | null
	} | null>(null)

	useImperativeHandle(ref, () => ({ handleResetFormValues }))

	const handleResetFormValues = () => {
		for (const [key, values] of Object.entries(formValues)) {
			if (values?.value || (errorMes && errorMes[key])) {
				setFormValues(initValues)
				setErrorMes(null)
				return
			}
		}
	}

	const router = useRouter()

	const formfields: IFormField[] = [
		{
			fieldType: 'input',
			name: 'fullName',
			label: 'Họ và tên',
			isRequired: true
		},
		{
			fieldType: 'date',
			name: 'birthday',
			label: 'Ngày tháng năm sinh',
			isRequired: true
		},
		{
			fieldType: 'select',
			name: 'industry',
			label: 'Ngành nghề',
			isRequired: true,
			option: industryOption ?? []
		},
		{
			fieldType: 'select',
			name: 'level',
			label: 'Kinh nghiệm làm việc',
			isRequired: true,
			option: levelsOption ?? []
		}
	]
	const onChange = (value: string, name: string) => {
		setFormValues({
			...formValues,
			[name]: {
				...formValues[name],
				value: value
			}
		})
		if (errorMes && errorMes[name]) {
			setErrorMes({
				...errorMes,
				[name]: null
			})
		}
	}
	const validate = (formValues: IFormValues) => {
		let isValid = false
		let error: { [key: string]: string | null } = {}
		for (const [name, data] of Object.entries(formValues)) {
			if (!data.value) {
				switch (name) {
					case 'level':
						if (error['industry'] === null && parseInt(formValues['industry'].value) !== NUMEROLOGY_CATEGORY_OTHER) {
							error = {
								...error,
								level: t('Vui lòng nhập thông tin')
							}
						}
						break
					default:
						if (name !== 'level')
							error = {
								...error,
								[name]: t('Vui lòng nhập thông tin')
							}
						break
				}

				continue
			} else {
				error = {
					...error,
					[name]: null
				}
			}
			const noSpecialChar = noSpecialChars.test(data.value)
			if (data.value && noSpecialChar) {
				switch (name) {
					case 'fullName':
						error = {
							...error,
							fullName:
								'Vui lòng không nhập số hoặc kí tự đặc biệt.'
						}
						break

					default:
						break
				}
				continue
			}
		}
		setErrorMes(error)
		for (const [name, data] of Object.entries(error)) {
			if (name && data) {
				isValid = false
				return
			}
			isValid = true
		}
		return isValid
	}
	const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const isValid = validate(formValues)
		if (isValid === true && user?.accessToken) {
			try {
				const body: IBodyCheckingNumerology = {
					fullName: formValues.fullName.value,
					birthday: new Date(formValues.birthday.value).toISOString(),
					industryId: Number(formValues.industry.value),
					levelName: formValues.level.value
				}
				const checkNumberByInfo =
					await serviceNumerology.checkNumerology(
						user.accessToken,
						body
					)
				if (checkNumberByInfo) {
					if (
						router.pathname === `${t('/numerology')}${t('/result')}`
					) {
						router.reload()
						return
					}
					router.push(`${t('/numerology')}${t('/result')}`)
					handleOpen()
				}
				return
			} catch (error) {
				console.error(error)
			}
		}
		return
	}
	const BirthDateCustomInput = (props) => {
		const {
			value = '',
			onClick = () => {},
			onChange = (_e: React.ChangeEvent) => {},
			onClear = () => {},
			error,
			placeholder
		} = props
		return (
			<Input
				hasError={error ? true : false}
				type='text'
				onClick={onClick}
				value={value}
				placeholder={placeholder}
				onChange={(value, e) => {
					if (e) {
						onChange(e)
					} else if (value === '') {
						onClear()
					}
				}}
			/>
		)
	}

	const getDropdownHeight = (): string => {
		// Mobile first
		if (typeof window === 'undefined' || isMobile() || window.screen.height <= 560) {
			return '150px'
		}
		if (window.screen.height <= 768) {
			return '200px'
		}
		return '300px'
	}

	const renderForm = (field: IFormField) => {
		switch (field.fieldType) {
			case 'input':
				return (
					<>
						<label>
							{t(field.label)}
							{field.isRequired ? <sup>*</sup> : null}
						</label>
						<Input
							maxLength={100}
							value={formValues[field.name].value}
							onChange={(value: string) => {
								onChange(value, field.name)
							}}
							placeholder={`${t('Nhập')} ${t(field.label)}`}
							hasError={
								errorMes && errorMes[field.name] ? true : false
							}
						/>
					</>
				)
			case 'date':
				return (
					<>
						<label>
							{t(field.label)}
							{field.isRequired ? <sup>*</sup> : null}
						</label>
						<DatePicker
							className='custom__date-picker'
							selected={
								(formValues[field.name]?.value as any) ?? null
							}
							filterDate={(date) => {
								return new Date() > date
							}}
							onChange={(date) => {
								if (date) {
									const birthday = new Date(
										date.getTime() -
											date.getTimezoneOffset() * 60000
									)
									setFormValues({
										...formValues,
										birthday: {
											value: birthday as any
										}
									})
									setErrorMes({
										...errorMes,
										birthday: null
									})
								}
							}}
							maxDate={new Date()}
							showPopperArrow={false}
							dateFormat='dd/MM/yyyy'
							placeholderText={'DD/MM/YYYY'}
							strictParsing
							showMonthDropdown
							showYearDropdown
							dropdownMode='select'
							customInput={
								<BirthDateCustomInput
									onClear={() =>
										setFormValues({
											...formValues,
											birthday: {
												value: ''
											}
										})
									}
									placeHolderText={'DD/MM/YYYY'}
									error={
										errorMes && errorMes[field.name]
											? true
											: false
									}
								/>
							}
						/>
					</>
				)
			case 'select':
				return (
					<>
						<label>
							{t(field.label)}
							{field.isRequired ? <sup>*</sup> : null}
						</label>
						<MultipleRadio
							options={field.option ?? []}
							name='Experience'
							placeholder={`${t('Chọn')}  ${t(field.label)}`}
							onChange={({ value }: { value: string }) => {
								onChange(value, field.name)
							}}
							value={formValues[field.name].value}
							dropdown={{
								isSearchable:
									field.name === 'level' ? false : true,
								maxHeight: getDropdownHeight()
							}}
							disable={
								field.name === 'level' &&
								(!formValues['industry']?.value || industryOther === NUMEROLOGY_CATEGORY_OTHER)
									? true
									: false
							}
							hasError={
								errorMes && errorMes[field.name] ? true : false
							}
						/>
					</>
				)
			default:
				break
		}
	}

	const getIndustry = async () => {
		try {
			const industryList = await serviceNumerology.getIndustryList()
			if (industryList) {
				const temp: IOption[] = []
				industryList.forEach((elm) => {
					if (elm.industryId !== null && elm.industryName) {
						temp.push({
							id: elm.industryId,
							name: elm.industryName
						})
					}
				})
				setIndustryOption(temp)
				setLevelsOption(null)

				return
			}
		} catch (error) {
			console.error(error)
		}
	}

	const getLevel = async (industryId: number) => {
		if (!user?.accessToken) return
		try {
			const levelList = await serviceNumerology.getLevelList(industryId)
			if (levelList) {
				const temp: IOption[] = []
				levelList.forEach((elm) => {
					if (elm.levelOrder !== null && elm.levelName) {
						temp.push({
							id: elm.levelName,
							name: elm.levelName
						})
					}
				})
				setLevelsOption(temp)
				setFormValues({
					...formValues,
					level: {
						value: ''
					}
				})
				return
			}
		} catch (error) {
			console.error(error)
		}
	}

	useEffect(() => {
		getIndustry()
	}, [])

	useEffect(() => {
		const industry = parseInt(formValues['industry'].value)
		if (industry &&  industry !== NUMEROLOGY_CATEGORY_OTHER) {
			getLevel(Number(formValues['industry'].value))
		} else {
			setFormValues({
				...formValues,
				level: {
					value: ''
				}
			})
		}
		setIndustryOther(industry)
	}, [formValues['industry']])

	return (
		<FormCss>
			<form className='form' onSubmit={onSubmit}>
				<Row gutter={16}>
					{formfields.map((field, index) => {
						return (
							<Col key={index} className='--relative'>
								{renderForm(field)}
								{errorMes && errorMes[field.name] ? (
									<p className='text-danger'>
										{errorMes[field.name]}
									</p>
								) : null}
							</Col>
						)
					})}
				</Row>
				<div className='form__button'>
					<Row>
						<Col>
							<Button
								type='primary'
								className='--button'
								htmlType='submit'
							>
								{t('Tra cứu')}
							</Button>
						</Col>
					</Row>
				</div>
			</form>
		</FormCss>
	)
}

export default React.forwardRef(FormCheckNumerology)
